export * from './roles'
export * from './slaConstants'
export * from './workflowConstants'
export * from './eventConstants'
export * from './layoutConstants'
export * from './maxRTEConstants'

export const SEND_MANUAL_COMMUNICATION_CONSTANT = {
  TEMPLATE_NAME: 'TEMPLATE_NAME',
  CONTAINS: 'CONTAINS',
  IS_ACTIVE: 'IS_ACTIVE',
  EQUALS: 'EQUALS',
  TRUE: 'TRUE',
  PRODUCT_ID: 'PRODUCT_ID',
  PRODUCT_ENTITY_NAME: 'products',
  ID: 'ID',
  PROGRAM_ID: 'PROGRAM_ID',
  SERVICE_ID: 'SERVICE_ID',
  CORRESPONDENCE_TYPE: 'CORRESPONDENCE_TYPE',
  DOCUMENT_NAME: 'DOCUMENT_NAME',
  ENABLED: 'ENABLED',
  PRODUCT: 'PRODUCT',
  SERVICE: 'SERVICE',
  PROGRAM: 'PROGRAM',
}

export const DASHBOARD_CONSTANTS = {
  BIOSIMILARS: 'Biosimilars',
  OVERSEEING: 'Overseeing',
  NO_PROGRAM_CONFIGURED:
    'There is no program configured for the client, please contact the administrator',
}
export const ENTITY_NAMES = {
  PAP_ELIGIBILITY_CONFIGURATIONS: 'pap_eligibility_configurations',
}

export const HCP_PORTAL_CONSTANTS = {
  REQUIRED_PORTAL_ID_ENROLLMENT_ID:
    'portalId and enrollmentFlowId are required',
}

export const ENROLLMENT_REVIEW_MODE = {
  LEGACY: 'legacy',
  DATA_REVIEW: 'data_review',
  CASE_TABS: 'case_tabs',
  INTAKE_REVIEW: 'intake_review',
} as const

export const isMultiProductAvailable = true
